/**
 * Ref callback for ScrollArea's viewportRef: makes a scrolling viewport a
 * named, focusable region so keyboard users can scroll it (WCAG 2.1.1).
 */
export function labelScrollRegion(label: string) {
  return (el: HTMLDivElement | null) => {
    if (!el) return;
    el.tabIndex = 0;
    el.setAttribute("role", "region");
    el.setAttribute("aria-label", label);
  };
}
